import { j as e } from "./atoms-v218.js";
import { Grid as C } from "./atoms-v216.js";
import { Footer as f } from "./atoms-v214.js";
import { Icon as c } from "./atoms-v217.js";
import { useBreakpoints as w } from "./atoms-v251.js";
import { Wrapper as L, ImageColumn as k, ImageWrapper as g, RoundedImage as x, ImageLabel as $, LabelText as n, Label as p, LabelButton as t, OneImageWrapper as v, Price as b } from "./atoms-v21031.js";
const o = (i, r, l, m, s) => {
  const a = i < l, d = Math.abs(i - l);
  return /* @__PURE__ */ e.jsxs(b, { $side: r, type: "body", variant: "expressive", children: [
    a ? "- " : "+ ",
    d.toLocaleString(m, {
      currency: s,
      style: "currency"
    })
  ] });
}, h = (i, r) => i === "small" && r === "twoRooms" ? "1/1" : ["large", "xLarge", "max"].includes(i) && r === "twoRooms" ? "16/9" : ["small", "large", "max", "xLarge"].includes(i) && r === "oneRoom" ? "2/1" : i === "medium" && r === "oneRoom" ? "16/9" : "4/3", z = (i, r, l, m, s, a) => /* @__PURE__ */ e.jsx(C, { children: /* @__PURE__ */ e.jsxs(k, { large: 8, max: 14, medium: 8, offset: { xLarge: 1 }, small: 4, xLarge: 14, children: [
  /* @__PURE__ */ e.jsxs(g, { onClick: i.onClick, children: [
    /* @__PURE__ */ e.jsx(
      x,
      {
        $variant: "twoRooms",
        alt: i.room.name,
        aspectRatio: h(l, "twoRooms"),
        defaultSource: i.room.image
      }
    ),
    /* @__PURE__ */ e.jsxs($, { children: [
      /* @__PURE__ */ e.jsx(n, { $side: "imageBottom", type: "body", variant: "expressive", children: i.room.name }),
      o(i.room.price, "imageBottom", m, s, a)
    ] })
  ] }),
  /* @__PURE__ */ e.jsxs(g, { onClick: r.onClick, children: [
    /* @__PURE__ */ e.jsx(
      x,
      {
        $variant: "twoRooms",
        alt: r.room.name,
        aspectRatio: h(l, "twoRooms"),
        defaultSource: r.room.image
      }
    ),
    /* @__PURE__ */ e.jsxs($, { children: [
      /* @__PURE__ */ e.jsx(n, { $side: "imageBottom", type: "body", variant: "expressive", children: r.room.name }),
      o(r.room.price, "imageBottom", m, s, a)
    ] })
  ] }),
  /* @__PURE__ */ e.jsxs(p, { $side: "previous", $variant: "twoRooms", onClick: i.onClick, children: [
    /* @__PURE__ */ e.jsx(t, { iconOnly: !0, $side: "previous", size: "expressive", variant: "primary", children: /* @__PURE__ */ e.jsx(c, { name: "arrow-left", size: "medium" }) }),
    /* @__PURE__ */ e.jsx(n, { $side: "previous", type: "heading", variant: "02", children: i.room.name }),
    o(i.room.price, "previous", m, s, a)
  ] }),
  /* @__PURE__ */ e.jsxs(p, { $side: "next", $variant: "twoRooms", onClick: r.onClick, children: [
    /* @__PURE__ */ e.jsx(t, { iconOnly: !0, $side: "next", size: "expressive", variant: "primary", children: /* @__PURE__ */ e.jsx(c, { name: "arrow-right", size: "medium" }) }),
    /* @__PURE__ */ e.jsx(n, { $side: "next", type: "heading", variant: "02", children: r.room.name }),
    o(r.room.price, "next", m, s, a)
  ] })
] }) }), I = (i, r, l, m, s) => i ? /* @__PURE__ */ e.jsx(C, { children: /* @__PURE__ */ e.jsxs(k, { large: 8, max: 14, medium: 8, offset: { xLarge: 1 }, small: 4, xLarge: 14, children: [
  /* @__PURE__ */ e.jsx(v, { onClick: i.onClick, children: /* @__PURE__ */ e.jsx(
    x,
    {
      $variant: "oneRoom",
      alt: i.room.name,
      aspectRatio: h(r, "oneRoom"),
      defaultSource: i.room.image
    }
  ) }),
  /* @__PURE__ */ e.jsxs(p, { $side: "next", $variant: "oneRoom", onClick: i.onClick, children: [
    /* @__PURE__ */ e.jsx(t, { iconOnly: !0, $side: "next", size: "expressive", variant: "primary", children: /* @__PURE__ */ e.jsx(c, { name: "arrow-right", size: "medium" }) }),
    /* @__PURE__ */ e.jsx(n, { $side: "next", type: "heading", variant: "02", children: i.room.name }),
    o(i.room.price, "next", l, m, s)
  ] })
] }) }) : null, V = ({
  currency: i = "USD",
  currentPrice: r,
  language: l = "en-US",
  links: m,
  nextRoomButton: s,
  previousRoomButton: a
}) => {
  const { current: d } = w();
  return /* @__PURE__ */ e.jsxs(L, { children: [
    a && s && z(a, s, d, r, l, i),
    (a && !s || !a && s) && I(a ?? s, d, r, l, i),
    /* @__PURE__ */ e.jsx(f, { children: m && m.map((j, y) => /* @__PURE__ */ e.jsx(f.Link, { href: j.href, children: j.text }, `footer-link-${y}`)) })
  ] });
};
export {
  V as Footer
};
